var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Wp_jd_select_for_member',{attrs:{"position_id":_vm.position_id,"keyword":_vm.keyword}})}
var staticRenderFns = []

export { render, staticRenderFns }